var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svgicon',{style:({width: (_vm.size + "rem"), height: (_vm.size + "rem")}),attrs:{"name":!_vm.hasStore ? 'Illustrative/Location' : 'Logos/' + _vm.translateStoreProfile,"role":"presentation","original":true}})}
var staticRenderFns = []

export { render, staticRenderFns }